/* crocs-megamenu @ 1.0.0 — mega menú de Crocs sobre los datos de la app mm51.

   Lee window.MM51_DATA (que crocs-header inyecta desde el metafield de tienda
   `mm51.menu_config`, o desde snippets/crocs-menu-demo mientras la app no esté
   instalada) y construye dos cosas:

     - desktop: un panel por cada item de tipo `megamenu`, con la fila de
       columnas del Figma 817:8032;
     - mobile: un cajón con dos niveles, la lista de categorías y el contenido
       de la categoría (Figma 1087:44898 y 1096:47226).

   Por qué un renderer propio y no el del parque (l51-megamenu-app.js): el
   diseño de Crocs no tiene barra de tabs, sus tarjetas llevan texto sobre la
   foto y su cajón mobile tiene dos niveles en vez de cuatro. Tocar el archivo
   compartido para eso le cambiaría el menú a las otras siete tiendas del
   parque; el contrato de datos, que es lo que importa, es el mismo.

   Convenciones de contenido (documentadas en snippets/crocs-menu-demo):
     - columna `images` con título -> pastilla gris arriba de la grilla;
     - `alt` de la imagen -> texto bajo la foto;
     - link que termina en 🔥 -> se pinta en verde;
     - primer link de una columna `links` -> hace de título de la columna. */
(function () {
  'use strict';

  var DATA = window.MM51_DATA;
  if (!DATA || !DATA.navbar || !DATA.navbar.items) return;

  var DESKTOP = '(min-width: 990px)';
  /* Menos que esto y pasar el mouse en diagonal hacia el panel lo cerraría. */
  var CLOSE_DELAY = 180;

  var megasById = {};
  (DATA.megamenus || []).forEach(function (m) { megasById[m.id] = m; });

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function isPromo(label) {
    return typeof label === 'string' && label.indexOf('🔥') !== -1;
  }

  /* ── Columnas ─────────────────────────────────────────────────────────── */

  function buildLinks(col) {
    var wrap = el('div', 'crocs-mm__col crocs-mm__col--links');
    var ul = el('ul', 'crocs-mm__links');

    (col.links || []).forEach(function (link, i) {
      if (!link || !link.label) return;
      var li = el('li');
      var a = el('a', 'crocs-mm__link', link.label);
      a.href = link.url || '#';
      /* El primero es el "Ver todo X" del diseño: 22 en vez de 18 y sin sangría. */
      if (i === 0) a.classList.add('crocs-mm__link--lead');
      if (isPromo(link.label)) a.classList.add('crocs-mm__link--promo');
      li.appendChild(a);
      ul.appendChild(li);
    });

    wrap.appendChild(ul);
    return wrap;
  }

  function buildMulticolumn(col) {
    var wrap = el('div', 'crocs-mm__col crocs-mm__col--multi');
    if (col.title) wrap.appendChild(colTitle(col.title));

    var row = el('div', 'crocs-mm__multi');
    (col.columns || []).forEach(function (group) {
      if (!group || !group.length) return;
      var ul = el('ul', 'crocs-mm__links');
      group.forEach(function (link) {
        if (!link || !link.label) return;
        var li = el('li');
        var a = el('a', 'crocs-mm__link', link.label);
        a.href = link.url || '#';
        if (isPromo(link.label)) a.classList.add('crocs-mm__link--promo');
        li.appendChild(a);
        ul.appendChild(li);
      });
      row.appendChild(ul);
    });

    wrap.appendChild(row);
    return wrap;
  }

  function colTitle(text) {
    return el('p', 'crocs-mm__coltitle', text);
  }

  function buildImages(col) {
    var images = col.images || [];
    var wrap = el('div', 'crocs-mm__col crocs-mm__col--images');
    if (col.title) wrap.appendChild(colTitle(col.title));

    /* Una sola imagen y sin título es el banner de la derecha del Figma: va
       entera, sin recuadro de texto encima. */
    if (images.length === 1 && !col.title) {
      wrap.classList.add('crocs-mm__col--promo');
      wrap.appendChild(tile(images[0], true));
      return wrap;
    }

    var grid = el('div', 'crocs-mm__tiles');
    images.forEach(function (img) { grid.appendChild(tile(img, false)); });
    wrap.appendChild(grid);
    return wrap;
  }

  function tile(img, isPromoTile) {
    var a = el('a', isPromoTile ? 'crocs-mm__promo' : 'crocs-mm__tile');
    a.href = (img && img.url) || '#';

    var box = el('span', isPromoTile ? 'crocs-mm__promo__img' : 'crocs-mm__tile__img');
    if (img && img.src) {
      var im = document.createElement('img');
      im.src = img.src;
      im.alt = (img.alt || '');
      im.loading = 'lazy';
      box.appendChild(im);
    }
    a.appendChild(box);

    if (!isPromoTile && img && img.alt) {
      a.appendChild(el('span', 'crocs-mm__tile__cap', img.alt));
    }
    /* Sin foto el enlace no tendría texto accesible. */
    if (isPromoTile && img && img.alt) {
      var sr = el('span', 'visually-hidden', img.alt);
      a.appendChild(sr);
    }
    return a;
  }

  function buildSizeGrid(col) {
    var wrap = el('div', 'crocs-mm__col crocs-mm__col--sizes');
    if (col.title) wrap.appendChild(colTitle(col.title));
    var grid = el('div', 'crocs-mm__sizes');
    (col.sizes || []).forEach(function (size) {
      var a = el('a', 'crocs-mm__size', size.label || '');
      a.href = size.url || '#';
      grid.appendChild(a);
    });
    wrap.appendChild(grid);
    return wrap;
  }

  function buildColumn(col) {
    var node;
    switch (col.type) {
      case 'links':             node = buildLinks(col); break;
      case 'links-multicolumn': node = buildMulticolumn(col); break;
      case 'images':            node = buildImages(col); break;
      case 'size-grid':         node = buildSizeGrid(col); break;
      default:                  node = el('div', 'crocs-mm__col');
    }
    var w = col.width || {};
    /* La piel reparte el ancho en proporción a este número, no en doceavos:
       es lo que deja la fila del Figma al ras (247 + 330x3 con 31 de aire). */
    node.style.setProperty('--crocs-mm-w', w.desktop || 3);
    return node;
  }

  /* Los tabs no existen en el diseño de Crocs. Si el JSON trae más de uno se
     dibujan todos seguidos, que es preferible a esconder contenido. */
  function columnsOf(mega) {
    var cols = [];
    (mega.tabs || []).forEach(function (tab) {
      (tab.columns || []).forEach(function (c) { cols.push(c); });
    });
    return cols;
  }

  /* ── Desktop ──────────────────────────────────────────────────────────── */

  var panelsHost, overlay, openId = null, closeTimer = null;

  function buildPanel(mega) {
    var panel = el('div', 'crocs-mm__panel');
    panel.id = 'crocs-mm-panel-' + mega.id;
    panel.hidden = true;

    var inner = el('div', 'crocs-mm__inner');
    var row = el('div', 'crocs-mm__row');
    columnsOf(mega).forEach(function (col) { row.appendChild(buildColumn(col)); });
    inner.appendChild(row);
    panel.appendChild(inner);

    return panel;
  }

  function openPanel(id, trigger) {
    cancelClose();
    if (openId === id) return;
    closePanel();

    var panel = document.getElementById('crocs-mm-panel-' + id);
    if (!panel) return;

    panel.hidden = false;
    /* Un reflow forzado y despues la clase: asi el navegador tiene un estado
       inicial desde el que animar. Con requestAnimationFrame la clase no llega
       nunca en los navegadores headless, y el panel se quedaba corrido. */
    void panel.offsetWidth;
    panel.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.documentElement.classList.add('crocs-mm-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    openId = id;
  }

  function closePanel() {
    if (!openId) return;
    var panel = document.getElementById('crocs-mm-panel-' + openId);
    if (panel) {
      panel.classList.remove('is-open');
      panel.hidden = true;
    }
    var t = document.querySelector('[data-crocs-mm-item="' + openId + '"]');
    if (t) t.setAttribute('aria-expanded', 'false');
    if (overlay) overlay.classList.remove('is-open');
    document.documentElement.classList.remove('crocs-mm-open');
    openId = null;
  }

  function scheduleClose() {
    cancelClose();
    closeTimer = setTimeout(closePanel, CLOSE_DELAY);
  }

  function cancelClose() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
  }

  function setupDesktop() {
    panelsHost = document.querySelector('[data-crocs-mm-panels]');
    if (!panelsHost) return;

    overlay = el('div', 'crocs-mm__overlay');
    overlay.addEventListener('click', closePanel);
    panelsHost.appendChild(overlay);

    DATA.navbar.items.forEach(function (item) {
      if (item.type !== 'megamenu') return;
      var mega = megasById[item.id];
      if (!mega || !columnsOf(mega).length) return;
      panelsHost.appendChild(buildPanel(mega));
    });

    /* Los enlaces del navbar los dibuja Liquid, con sus clases del Figma; acá
       solo se les cuelga el comportamiento. Cuando el menú viene del respaldo
       del theme no traen id, así que se emparejan por texto. */
    var links = document.querySelectorAll('.crocs-header__nav__link');
    var byLabel = {};
    DATA.navbar.items.forEach(function (i) { byLabel[(i.label || '').trim()] = i; });

    Array.prototype.forEach.call(links, function (a) {
      var item = a.getAttribute('data-crocs-mm-item')
        ? megasById[a.getAttribute('data-crocs-mm-item')] && { id: a.getAttribute('data-crocs-mm-item'), type: 'megamenu' }
        : byLabel[a.textContent.trim()];
      if (!item || item.type !== 'megamenu') return;
      if (!document.getElementById('crocs-mm-panel-' + item.id)) return;

      a.setAttribute('data-crocs-mm-item', item.id);
      a.setAttribute('aria-expanded', 'false');
      a.setAttribute('aria-controls', 'crocs-mm-panel-' + item.id);

      a.addEventListener('mouseenter', function () { openPanel(item.id, a); });
      a.addEventListener('focus', function () { openPanel(item.id, a); });
      /* El clic sigue navegando a la colección: el panel es un complemento, no
         un reemplazo del enlace. En pantallas táctiles anchas el primer toque
         abre y el segundo navega. */
      a.addEventListener('click', function (event) {
        if (!window.matchMedia(DESKTOP).matches) return;
        if (event.pointerType === 'touch' && openId !== item.id) {
          event.preventDefault();
          openPanel(item.id, a);
        }
      });
    });

    /* El cierre cuelga de la barra entera y no de cada enlace: los paneles son
       descendientes suyos, asi que bajar del enlace al panel no dispara su
       `mouseleave` y no hay carrera contra el temporizador. Colgado de cada
       enlace, el menu se cerraba al pasar de un item a otro o al bajar. */
    var bar = document.querySelector('.crocs-header__bar');
    if (bar) {
      bar.addEventListener('mouseenter', cancelClose);
      bar.addEventListener('mouseleave', scheduleClose);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePanel();
    });
  }

  /* ── Mobile ───────────────────────────────────────────────────────────── */

  var drawer, drawerLevel2;

  function chevron() {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 32 32');
    s.setAttribute('fill', 'none');
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('class', 'crocs-mm-drawer__chev');
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', 'M13 10L19 16L13 22');
    p.setAttribute('stroke', 'currentColor');
    p.setAttribute('stroke-width', '2');
    p.setAttribute('stroke-linecap', 'round');
    p.setAttribute('stroke-linejoin', 'round');
    s.appendChild(p);
    return s;
  }

  function buildDrawerLevel1() {
    var list = el('div', 'crocs-mm-drawer__list');

    DATA.navbar.items.forEach(function (item) {
      var mega = item.type === 'megamenu' ? megasById[item.id] : null;
      var hasContent = mega && columnsOf(mega).length;

      var node = el(hasContent ? 'button' : 'a', 'crocs-mm-drawer__row');
      if (hasContent) {
        node.type = 'button';
        node.addEventListener('click', function () { goLevel2(mega, item.label); });
      } else {
        node.href = item.url || '#';
      }

      var label = el('span', 'crocs-mm-drawer__row__label', item.label || '');
      if (item.style && item.style.color) label.style.color = item.style.color;
      node.appendChild(label);
      if (hasContent) node.appendChild(chevron());
      list.appendChild(node);
    });

    return list;
  }

  function goLevel2(mega, label) {
    drawerLevel2.textContent = '';

    var back = el('button', 'crocs-mm-drawer__back');
    back.type = 'button';
    back.appendChild(chevron());
    back.appendChild(el('span', null, 'Menú Principal'));
    back.addEventListener('click', function () {
      drawer.classList.remove('is-level2');
      drawerLevel2.setAttribute('aria-hidden', 'true');
    });
    drawerLevel2.appendChild(back);

    var body = el('div', 'crocs-mm-drawer__body');
    columnsOf(mega).forEach(function (col) { body.appendChild(buildColumn(col)); });
    drawerLevel2.appendChild(body);

    drawer.classList.add('is-level2');
    drawerLevel2.setAttribute('aria-hidden', 'false');
    drawerLevel2.scrollTop = 0;
  }

  function openDrawer() {
    drawer.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.documentElement.classList.add('crocs-mm-drawer-open');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open', 'is-level2');
    document.documentElement.classList.remove('crocs-mm-drawer-open');
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 250);
  }

  function setupMobile() {
    var host = document.querySelector('[data-crocs-mm-drawer]');
    var trigger = document.querySelector('[data-crocs-mm-open]');
    if (!host || !trigger) return;

    drawer = host;
    var level1 = host.querySelector('[data-crocs-mm-level1]');
    drawerLevel2 = host.querySelector('[data-crocs-mm-level2]');
    if (!level1 || !drawerLevel2) return;

    /* La lista va antes del bloque de ayuda, que lo dibuja Liquid. */
    level1.insertBefore(buildDrawerLevel1(), level1.firstChild);

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openDrawer();
    });

    Array.prototype.forEach.call(host.querySelectorAll('[data-crocs-mm-close]'), function (b) {
      b.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  function init() {
    setupDesktop();
    setupMobile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
